import { render, staticRenderFns } from "./froalaEditor.vue?vue&type=template&id=5df8b9df&"
import script from "./froalaEditor.vue?vue&type=script&lang=js&"
export * from "./froalaEditor.vue?vue&type=script&lang=js&"
import style0 from "./froalaEditor.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/_vue-loader@15.9.8@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports